// extracted by mini-css-extract-plugin
export default {"root":"PE5mNoXFkh","buttonContainer":"GQaTFXOeOb"};